export enum IncidentAlertAction {
  IGNORE = 'IGNORE',
  INVESTIGATE = 'INVESTIGATE',
}
